import { render, staticRenderFns } from "./bfhs-tile.vue?vue&type=template&id=1c668870&"
import script from "./bfhs-tile.vue?vue&type=script&lang=js&"
export * from "./bfhs-tile.vue?vue&type=script&lang=js&"
import style0 from "./bfhs-tile.vue?vue&type=style&index=0&id=1c668870&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports